import { Button } from 'antd';
import writeXlsxFile from 'write-excel-file';
import dayjs from 'dayjs';
import { getTaxStatus, getInvoiceStatus } from '../../../utils/common';

const schema = [
  {
    column: 'Customer',
    type: String,
    value: row => `${row.customer.name} (${row.customer.code})`,
  },
  {
    column: 'Invoice Date',
    type: String,
    value: row => dayjs(row.invoice_date).format('MM/DD/YYYY'),
  },
  {
    column: 'Invoice Due Date',
    type: String,
    value: row => dayjs(row.invoice_due_date).format('MM/DD/YYYY'),
  },
  {
    column: 'Invoice Price ($)',
    type: Number,
    value: row => {
      const salePrice = +row.sub_total - +row.total_discount;
      return +salePrice;
    },
  },
  {
    column: 'Estimated Tax ($)',
    type: Number,
    value: row => {
      let tax = 0;
      if (row.avalara_response?.summary?.length > 0) {
        row.avalara_response.summary.map(taxSummary => {
          if (+taxSummary.tax > 0) {
            tax += +taxSummary.tax;
          }
        })
      }
      return +tax;
    },
  },
  {
    column: 'Payments/Credit ($)',
    type: Number,
    value: row => +row.credits,
  },
  {
    column: 'Total ($)',
    type: Number,
    value: row => {
      let total = +row.total;
      if (row.avalara_response?.summary?.length > 0) {
        row.avalara_response.summary.map(taxSummary => {
          if (+taxSummary.tax > 0) {
            total += +taxSummary.tax;
          }
        })
      }
      return +total;
    },
  },
  {
    column: 'Tax Status',
    type: String,
    value: row => {
      let value = row.status;
      if (!row.is_taxed) {
        value = -1;
      }
      return getTaxStatus(value)
    },
  },
  {
    column: 'Invoice Status',
    type: String,
    value: row => getInvoiceStatus(row.invoice_status),
  },
  {
    column: 'Invoice Submit Date',
    type: String,
    value: row => {
      if (+row.invoice_status !== 0) {
        return dayjs(row.invoice_submit_date).format('MM/DD/YYYY');
      }
      return '';
    },
  },
  {
    column: 'Invoice Paid Date',
    type: String,
    value: row => {
      if (+row.invoice_status === 2) {
        return dayjs(row.invoice_pay_date).format('MM/DD/YYYY');
      }
      return '';
    },
  },
];

export default ({ data, sheetName = 'Invoice' }) => {
  const handleExport = async () => {
    await writeXlsxFile(data, {
      fileName: `${sheetName}.xlsx`,
      sheet: sheetName,
      schema,
    });
  };

  return <Button onClick={handleExport}>Export to Excel</Button>;
};
